import React, { useState } from "react";
import {
  Form,
  Button,
  Col,
  Alert,
  Card,
  Nav,
  Row,
  Container,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import PublicPatientForm from "./Patient/PublicPatientForm";
import demoDoctors from "../assets/images/LoginPage.png"; // Demo Image
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("login");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`${BASE_URL}/api/auth/login`, {
        email,
        password,
      });

      if (response.data && response.status === 200) {
        const { user, role, token } = response.data;
        const hospitalId = user.hospital_id;
        const subHospitalId = user.sub_hospital_id;

        if (!user || !token || !role) {
          setError("Invalid login response from server");
          return;
        }

        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("token", token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        localStorage.setItem("role", role);
        localStorage.setItem("hospitalId", hospitalId);
        localStorage.setItem("subHospitalId", subHospitalId);

        // Fetch and store role-specific ID
        try {
          // Always send role as backend expects (admin, doctor, patient, receptionist, lab, super_admin)
          let roleParam = (role || '').toLowerCase();

          if (roleParam !== 'super_admin') {
            const idResponse = await axios.get(`${BASE_URL}/api/auth/get-role-specific-id`, {
              headers: { Authorization: `Bearer ${token}` },
              params: { email: user.email, role: roleParam },
            });
            if (roleParam === 'patient') {
              localStorage.setItem('patient_id', idResponse.data.id);
            } else if (roleParam === 'doctor') {
              localStorage.setItem('doctor_id', idResponse.data.id);
            } else if (roleParam === 'receptionist') {
              localStorage.setItem('receptionist_id', idResponse.data.id);
            } else if (roleParam === 'lab') {
              localStorage.setItem('lab_id', idResponse.data.id);
            } else if (roleParam === 'admin') {
              localStorage.setItem('admin_id', idResponse.data.id);
            } else if (roleParam === 'super_admin') {
              localStorage.setItem('super_admin_id', idResponse.data.id);
            }
          }
        } catch (error) {
          // Show backend error message if present
          const errMsg = error?.response?.data?.message || error?.response?.data?.error || error.message || "Failed to fetch role ID";
          console.error(`Error fetching ${role} ID:`, errMsg);
          toast.error(`Failed to fetch ${role} ID. ${errMsg}`);
        }

        login(user, token);

        switch (role) {
          case "admin":
            navigate("/admin", { replace: true });
            break;
          case "doctor":
            navigate("/doctor", { replace: true });
            break;
          case "patient":
            navigate("/patient", { replace: true });
            break;
          case "receptionist":
            navigate("/receptionist", { replace: true });
            break;
          case "lab":
            navigate("/lab", { replace: true });
            break;
          case "super_admin":
            navigate("/super_admin", { replace: true });
            break;
          default:
            navigate("/login");
            break;
        }
      } else {
        setError("Invalid username or password");
      }
    } catch (err) {
      console.error("Error:", err);
      setError("An error occurred while logging in");
    }
  };

  return (
    <Container
      fluid
      className="min-vh-100 d-flex align-items-center justify-content-center "

    >
      <Card
        md={12}
        className="shadow-lg w-100 h-100"
        style={{ minHeight: "100vh" }}

      >
        <Row className="g-0 flex-column flex-md-row h-100">
          <Col
            xs={12}
            md={12}
            lg={6}
            className="d-flex flex-column justify-content-center align-items-center text-white p-4"
            style={{ backgroundColor: "#0A7884",minHeight: "100vh" }}
          >
            <div className="text-center">
              <Container>
                <Row className="justify-content-center">
                  <Col xs={10} md={10} lg={12} className="text-center">
                    <img
                      src={demoDoctors}
                      alt="Doctors"
                      className="login-full-image"
                    />
                  </Col>
                </Row>
              </Container>

            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            className="d-flex justify-content-center align-items-start p-4"
          >
            <div className="w-100" style={{ maxWidth: "550px" }}>
              <Nav
                variant="tabs"
                className="mb-4 justify-content-center"
                activeKey={activeTab}
                onSelect={(selectedKey) => setActiveTab(selectedKey)}
              >
                <Nav.Item className="flex-fill text-center">
                  <Nav.Link
                    eventKey="login"
                    className={`fw-bold ${activeTab === "login" ? "primary-class " : "text-secondary"}`}
                  >
                    Login
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="flex-fill text-center">
                  <Nav.Link
                    eventKey="register"
                    className={`fw-bold ${activeTab === "register" ? "primary-class border-bottom-3" : "text-secondary"}`}
                  >
                    Register
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              {/* Form container */}
              <div className="mt-1">
                {activeTab === "login" ? (
                  <>
                    <h3 className="text-center mb-4 fw-bold primary-class">Login</h3>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form onSubmit={handleLogin}>
                      <Form.Group controlId="formBasicEmail" className="mb-3 fw-semibold primary-class">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </Form.Group>
                      <Form.Group controlId="formBasicPassword" className="mb-4 fw-semibold primary-class">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Enter Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </Form.Group>
                      <Button type="submit" className="w-100 fw-bold btn-custom" >
                        Log In
                      </Button>
                    </Form>
                  </>
                ) : (
                  <>
                    <h3 className="text-center mb-4 fw-bold primary-class">Register</h3>
                    <PublicPatientForm />
                  </>
                )}
              </div>
            </div>
          </Col>

        </Row>
      </Card>
    </Container>
  );
};

export default Login;
